module.exports = __webpack_public_path__ + "img/item2.a3a924c6.svg";